module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "crossDeviceTesting.0a9daeae.png";